module.exports = __webpack_public_path__ + "media/images/facilities/projecter-49963744b8b186edfae2ae3375e59e8a.png";